import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=8c981f96&scoped=true"
import script from "./TheTopbar.vue?vue&type=script&lang=js"
export * from "./TheTopbar.vue?vue&type=script&lang=js"
import style0 from "./TheTopbar.vue?vue&type=style&index=0&id=8c981f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c981f96",
  null
  
)

export default component.exports